// Shared types + helpers for the ClientPortal subcomponents. Lifted out of
// ClientPortal.tsx during the 2026-05-01 split.

export type SeverityFilter = 'all' | 'safety_concern' | 'recommendation';

/**
 * Convert a hex color (#rrggbb or #rgb) into a space-separated RGB triple
 * for use in CSS custom properties (so `rgb(var(--brand) / 0.5)` works).
 * Falls back to brand-500 green (#2F6A44) on invalid input.
 */
export function hexToRgbTriplet(hex: string | null | undefined, fallback = '47 106 68'): string {
  if (!hex) return fallback;
  const h = hex.replace('#', '').trim();
  const expanded = h.length === 3 ? h.split('').map(c => c + c).join('') : h;
  if (!/^[0-9a-fA-F]{6}$/.test(expanded)) return fallback;
  const n = parseInt(expanded, 16);
  return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`;
}
